import React from "react";
import { Building2 } from "lucide-react";
import { TspCard } from "../../../components/primitives";

// Up to 9 latest photos with caption and uploading temple.
export default function RecentActivitiesStrip({ items }) {
  const displayItems = (items || []).slice(0, 9);

  return (
    <TspCard title="Recent Activities" className="tsp-recent-activities-card">
      {displayItems.length === 0 && <p className="tsp-muted-text">No photos uploaded yet.</p>}
      <div className="tsp-recent-activities-strip">
        {displayItems.map((item) => (
          <div key={item.id} className="tsp-recent-activity-card">
            <div className="tsp-recent-activity-thumb">
              <img src={item.image} alt={item.caption || "Recent TSP activity"} loading="lazy" />
            </div>
            {(item.caption || item.templeName) && (
              <div className="tsp-recent-activity-info">
                {item.caption && <p className="tsp-recent-activity-caption">{item.caption}</p>}
                {item.templeName && (
                  <span className="tsp-recent-activity-temple">
                    <Building2 size={12} aria-hidden="true" />
                    <span>{item.templeName}</span>
                  </span>
                )}
              </div>
            )}
          </div>
        ))}
      </div>
    </TspCard>
  );
}
